






















import { Component, Prop, Vue, Watch} from 'vue-property-decorator';
import moment from 'moment';
import { isLogin, getExp,getTaskExp,getTaskExpColumns } from '@/global/utils';
import { DOMAIN } from '@/global/constants';

@Component
export default class TrainDetailHeader extends Vue {
  @Prop() private task!: object;
  // 显示数据模型
  private taskSchema: any;
    //任务显示经验值
  private taskExp: any;
  //任务详情页经验值title
  private columns: any;

  get myExp(){
    return this.$store.state.myExp;
  }
  @Watch('myExp')
  private userIdChange(to: any, from: any) {
    if(to){
      const list=getTaskExp(this.task,this);
      list.forEach((item, index) => {
        Vue.set(this.taskExp, index, item)
      })
      // this.taskExp = getTaskExp(this.task,this);
    }
  }
  private created() {
    this.taskSchema = this.getTrainSchema(this.task);
    this.taskExp = getTaskExp(this.task,this);
    this.columns = getTaskExpColumns();
  }
  // 获取练习数据模型
  private getTrainSchema(data) {
    return [
      {
      label: '任务发布',
      key: 'ownerName',
      value: data.ownerName || '',
      },
      {
        label: '编号',
        key: 'id',
        value: data.id || '',
      },
      {
        label: '题数',
        key: 'nums',
        value: data.nums || '0',
      },
      {
        label: '结束时间',
        key: 'end_time',
        value: moment(data.end_time * 1000 || '').format('YYYY-MM-DD HH:mm:ss'),
      }
    ];
  }
  // 去练习(train)
  private goPractice() {
    if (!isLogin(this)) {
      return;
    }
    let task: any = this.task;
    window.open(
      `${DOMAIN}/tools/${task.from}.html?type=60&id=${task.id}&gid=${
        task.gid
      }&scores=${task.statistics ? task.statistics.scores : 0}`
    );
  }
  // 跳转人工审核列表
  private goCheck() {
    if (!isLogin(this)) {
      return;
    }
    const task: any = this.task;
    this.$router.push({
      name: 'traincheck',
      params: { id: task.id },
    });
  }
}
